import posthog from "posthog-js";

/**
 * Whether feature flags can ever resolve in this build.
 *
 * With no project token `PostHogProvider` mounts no client at all, so
 * `useFeatureFlagEnabled` returns `undefined` FOREVER rather than briefly —
 * `undefined` means "still loading" only when there is something to load from.
 * Any UI that waits on a flag must consult this first or it waits forever
 * (which is exactly what blanked the intake page under e2e, where no token is
 * set). Same condition `PostHogProvider` gates its own mount on; keep the two
 * together.
 */
export function featureFlagsAvailable(): boolean {
  return Boolean(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN);
}

export function initPostHog() {
  if (typeof window === "undefined") return;

  const key = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
  console.log("[posthog] token present:", !!key, "len:", key?.length);
  const host =
    process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

  if (!key) return;

  posthog.init(key, {
    api_host: "/ingest",
    ui_host: host,
    person_profiles: "identified_only",
    capture_pageview: false, // handled manually for SPA navigation
  });
}

export { posthog };
